<template>
    <div>
        <answer-portrait :h5ConfigData="h5ConfigData" :owner="owner"></answer-portrait>
        <div class="answer-content" v-if="reply.CardType === 1 && reply.Title" :class="{ answerContentSjtu: owner === 'SJTU' }">
            <div v-for="(item, index) in reply.Title" :key="index" v-html="item"></div>
            <!-- <div class="feedback">
                <div @click="approvalHandle(reply)" class="approval">
                    <img alt v-if="approvalStatus" src="../../assets/iconfont/approval.svg" />
                    <img alt v-else src="../../assets/iconfont/approval-click.svg" />
                    <span :class="{ approvalStatus: !approvalStatus }">有用</span>
                </div>
                <div @click="opposeHandle(reply)" class="oppose">
                    <img alt v-if="opposeStatus" src="../../assets/iconfont/oppose.svg" />
                    <img alt v-else src="../../assets/iconfont/oppose-click.svg" />
                    <span :class="{ opposeStatus: !opposeStatus }">没用</span>
                </div>
            </div> -->
        </div>
        <div class="answer-content-img" v-if="reply.CardType === 2" style="padding-bottom: 14px">
            <div v-for="(item, index) in reply.Items" :key="index">
                <video-player
                    v-if="item.PicUrl && (item.PicUrl.substr(-4) === '.mp4' || item.PicUrl.substr(-4) === '.avi')"
                    ref="videoPlayer"
                    class="video-player vjs-custom-skin"
                    :playsinline="true"
                    :options="playerOptions"
                />

                <div
                    v-if="item.PicUrl && item.PicUrl.substr(-4) !== '.mp4' && item.PicUrl.substr(-4) !== '.avi'"
                    class="item-img"
                    :style="{ 'background-image': `url(${item.PicUrl})` }"
                    @click="setPreviewImg(item.PicUrl)"
                ></div>
                <div v-if="item.Title" class="item-tt" v-html="item.Title"></div>
                <div v-if="item.Description" class="item-desc">
                    <p v-for="(_item, _index) in item.Description" :key="_index" v-if="_item !== '点击查看'" v-html="_item"></p>
                </div>
                <a v-if="item.Url" class="item-link" :href="item.Url"> {{ item.link_tip }}</a>
            </div>
            <!-- <div class="feedback">
                <div @click="approvalHandle(reply)" class="approval">
                    <img alt v-if="approvalStatus" src="../../assets/iconfont/approval.svg" />
                    <img alt v-else src="../../assets/iconfont/approval-click.svg" />
                    <span :class="{ approvalStatus: !approvalStatus }">有用</span>
                </div>
                <div @click="opposeHandle(reply)" class="oppose">
                    <img alt v-if="opposeStatus" src="../../assets/iconfont/oppose.svg" />
                    <img alt v-else src="../../assets/iconfont/oppose-click.svg" />
                    <span :class="{ opposeStatus: !opposeStatus }">没用</span>
                </div>
            </div> -->
        </div>
        <div class="answer-content card-type-3" v-if="reply.CardType === 3" style="padding-bottom: 20px">
            <div class="card-type-3-tt" v-html="reply.Title"></div>
            <a v-for="(item, index) in reply.Items" :key="index" target="_blank" :href="item.Url" class="card-type-3-ct">
                <div class="item-mn">
                    <div class="item-tt" v-html="item.Title"></div>
                    <div class="item-desc" v-html="item.Description"></div>
                </div>
                <div class="item-img" :style="{ 'background-image': `url(${item.PicUrl})` }"></div>
            </a>
            <!-- <div class="feedback">
                <div @click="approvalHandle(reply)" class="approval">
                    <img alt v-if="approvalStatus" src="../../assets/iconfont/approval.svg" />
                    <img alt v-else src="../../assets/iconfont/approval-click.svg" />
                    <span :class="{ approvalStatus: !approvalStatus }">有用</span>
                </div>
                <div @click="opposeHandle(reply)" class="oppose">
                    <img alt v-if="opposeStatus" src="../../assets/iconfont/oppose.svg" />
                    <img alt v-else src="../../assets/iconfont/oppose-click.svg" />
                    <span :class="{ opposeStatus: !opposeStatus }">没用</span>
                </div>
            </div> -->
        </div>
        <div class="answer-content-img answer-content card-type-4" v-if="reply.CardType === 4" style="padding-bottom: 20px">
            <div v-for="(item, index) in reply.Items" :key="index">
                <video-player
                    v-if="item.PicUrl && (item.PicUrl.substr(-4) === '.mp4' || item.PicUrl.substr(-4) === '.avi')"
                    ref="videoPlayer"
                    class="video-player vjs-custom-skin"
                    :playsinline="false"
                    :options="playerOptions"
                />

                <img
                    :key="'longimg' + index"
                    v-if="item.PicUrl && (item.PicUrl.substr(-4) !== '.mp4' || item.PicUrl.substr(-4) !== '.avi')"
                    class="answer-content-longimg"
                    :src="item.PicUrl"
                    alt
                    @click="setPreviewImg(item.PicUrl)"
                />
            </div>
            <!-- <div class="feedback">
                <div @click="approvalHandle(reply)" class="approval">
                    <img alt v-if="approvalStatus" src="../../assets/iconfont/approval.svg" />
                    <img alt v-else src="../../assets/iconfont/approval-click.svg" />
                    <span :class="{ approvalStatus: !approvalStatus }">有用</span>
                </div>
                <div @click="opposeHandle(reply)" class="oppose">
                    <img alt v-if="opposeStatus" src="../../assets/iconfont/oppose.svg" />
                    <img alt v-else src="../../assets/iconfont/oppose-click.svg" />
                    <span :class="{ opposeStatus: !opposeStatus }">没用</span>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import AnswerPortrait from './AnswerPortrait.vue'
import { getJudge } from '../../Service/api'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  props: {
    h5ConfigData: {
      type: Object
    },

    reply: {
      type: Object
    },

    owner: String
  },
  data () {
    return {
      approvalStatus: 1,
      opposeStatus: 1,
      playerOptions: {
        controls: true,
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '' // url地址
          }
        ],
        hls: true,
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      }
    }
  },
  components: {
    AnswerPortrait,
    videoPlayer
  },
  mounted () {
    console.log('>?>?>?', this.reply)
    if (this.reply && this.reply.Items && (this.reply.Items[0].PicUrl.substr(-4) === '.mp4' || this.reply.Items[0].PicUrl.substr(-4) === '.avi')) {
      this.playerOptions.sources[0].src = this.reply.Items[0].PicUrl
    }
  },

  methods: {
    setPreviewImg (picUrl) {
      this.$emit('setPreviewImg', picUrl)
    },
    approvalHandle (reply) {
      this.approvalStatus = 0
      this.opposeStatus = 1
      const conversition = JSON.parse(
        sessionStorage.getItem('h5conversation')
      )
      console.log('conversition', conversition)
      let answer
      let question
      if (reply.CardType === 1) {
        answer = reply.Title[0]
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 1) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Title[0] === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      } else if (reply.CardType === 2 || reply.CardType === 3) {
        answer = reply.Items[0].Title
        console.log('answer', answer)
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 2) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Items[0].Title === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      } else if (reply.CardType === 4) {
        answer = reply.Items[0].PicUrl
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 4) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Items[0].PicUrl === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      }
      const params = {
        productId: this.h5ConfigData.productId,
        userId: localStorage.getItem('userId'),
        query: question,
        answer: answer,
        feedback: 0,
        recordId: reply.recordId
      }
      this.getJudgeData(params)
    },
    opposeHandle (reply) {
      this.opposeStatus = 0
      this.approvalStatus = 1
      const conversition = JSON.parse(
        sessionStorage.getItem('h5conversation')
      )
      console.log('conversition', conversition)
      let answer
      let question
      if (reply.CardType === 1) {
        answer = reply.Title[0]
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 1) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Title[0] === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      } else if (reply.CardType === 2 || reply.CardType === 3) {
        answer = reply.Items[0].Title
        console.log('answer', answer)
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 2) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Items[0].Title === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      } else if (reply.CardType === 4) {
        answer = reply.Items[0].PicUrl
        for (let item = 0; item < conversition.length; item++) {
          if (conversition[item].content && conversition[item].content.reply && conversition[item].content.reply.CardType === 4) {
            console.log('item0', conversition[item])
            if (conversition[item].content.reply.Items[0].PicUrl === answer) {
              question = conversition[item - 1].content
            }
          }
        }
      }
      const params = {
        productId: this.h5ConfigData.productId,
        userId: localStorage.getItem('userId'),
        query: question,
        answer: answer,
        feedback: 1,
        recordId: reply.recordId
      }
      this.getJudgeData(params)
    },
    getJudgeData (params) {
      getJudge(params).then(res => {
        console.log('反馈', res)
      })
    },

    // onPlayerPlay (e) {
    //   this.$refs.videoPlayer.player.play()
    // },
    // onPlayerPause (e) {
    //   this.$refs.videoPlayer.player.pause()
    // },
    async judgeNetWork () {
      const commonCell = ['cellular', '2g', '3g', '4g', '5g', '3G/2G']
      const userAgent = navigator.userAgent.toLowerCase()
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || { type: 'unknown' }
      let type
      // 判断是否是微信内置浏览器
      const isWeixin = /micromessenger/.test(userAgent)
      return new Promise(async (resolve, reject) => {
        if (isWeixin) {
          await this.getwNetwork()
          resolve()
        } else {
          let newType
          type = (connection && connection.type) || 'unknown'
          if (type && commonCell.indexOf(type) !== -1) {
            newType = 'cellular'
            this.$confirm('当前播放需要流量, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs.videoPlayer.player.play()
            }).catch((e) => {
              console.log(e)
            })
          } else if (type === 'wifi') {
            newType = 'wifi'
            this.$refs.videoPlayer.player.play()
          } else {
            newType = 'unknown'
          }
          localStorage.setItem('network', newType)
          resolve()
        }
      })
    },

    getwNetwork () {
      return new Promise((resolve) => {
        wx.getNetworkType({
          success: function (res) {
            let wType = 'wifi'
            if (res.networkType !== 'wifi') {
              wType = 'cellular'
              alert(wType + '99')
              this.$confirm('当前播放需要流量, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$refs.videoPlayer.player.play()
              }).catch((e) => {
                console.log(e)
              })
            } else {
              this.$refs.videoPlayer.player.play()
            }
            localStorage.setItem('network', wType)
            resolve()
          },
          fail: function (res) {
            console.log('调用失败----', res)
            localStorage.setItem('network', 'unknown')
            resolve()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.answer {
    &-content {
        position: relative;
        max-width: 560px;
        padding: 20px 24px;
        line-height: 44px;
        font-size: 32px; /*px*/
        word-break: break-all;
        word-wrap: word-break;
        text-align: justify;
        font-weight: 400;
        color: #111e2e;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
        border-radius: 12px;
        overflow: hidden;

        &-tt {
            padding: 4px 0 8px;
            font-weight: 400;
        }

        &.card-type-3 {
            .card-type-3-tt {
                padding: 12px 0 8px;
            }

            .card-type-3-ct {
                display: flex;
                padding: 16px 0;
                color: inherit;
                overflow: hidden;

                .item-img {
                    flex: none;
                    width: 128px;
                    height: 128px;
                    background: no-repeat center center;
                    background-size: cover;
                }

                .item-mn {
                    flex: 1;
                    margin-left: 32px;
                    padding-top: 4px;
                    line-height: 44px;
                    overflow: hidden;
                }

                .item-tt {
                    font-size: 32px;
                    font-weight: 400;
                    color: #34404d;
                    line-height: 46px;

                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    padding: 20px 24px;
                }

                .item-desc {
                    font-size: 26px;
                    font-weight: 400;
                    color: #949aa1;
                    line-height: 40px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    padding: 0px 24px;
                }
            }

            .card-type-3-ct + .card-type-3-ct {
                border-top: 2px solid #e4e7ed;
            }
        }
    }

    &-content-img {
        width: 560px;
        // padding: 20px 24px;
        line-height: 44px;
        font-size: 32px; /*px*/
        word-break: break-all;
        word-wrap: word-break;
        color: #111e2e;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
        border-radius: 12px;
        overflow: hidden;

        .item-img {
            height: 250px;
            background: no-repeat center center;
            background-size: 100%, 100%;
        }
        .item-tt {
            padding: 12px 24px 0px;
        }

        .item-desc {
            padding: 12px 24px;

            > p {
                margin: 0;
                line-height: 40px;
            }
        }

        .item-link {
            display: block;
            padding: 12px 24px;
            color: #4e82ff;
        }
    }

    &-content-longimg {
        width: 560px;
        border-radius: 12px;
    }
}
.answerContentSjtu {
    background: #f3f4f6;
    border: none;
}
.feedback {
    border-top: 1px solid #eaebec;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-top: 20px;
    margin-top: 20px;
    .approval,
    .oppose {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 50px;
            height: 50px;
        }
        span {
            color: #646d77;
            font-size: 28px;
        }
        .approvalStatus,
        .opposeStatus {
            color: #4e82ff;
        }
    }
}
.card-type-4 {
    padding: 0 0 14px;
}
.top {
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    flex: 1;
    position: relative;
}
.videoTop {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
}
</style>
<style>
.el-message-box {
    width: 90%;
}
.el-message-box__header {
    position: relative;
    padding: 36px 36px 24px;
}
.el-message-box__title {
    font-size: 36px;
}
.el-message-box__content {
    padding: 24px 36px;
    font-size: 30px;
}
.el-message-box__status {
    font-size: 36px !important;
}
.el-message-box__btns {
    padding: 12px 36px 36px;
    text-align: right;
}
.el-button--small,
.el-button--small.is-round {
    padding: 12px 24px;
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/AnswerReply.vue